import ArticleBody from "./ArticleBody";
import Breadcrumb from "./Breadcrumb";
import Faq from "./Faq";
import Related from "./Related";
import "./templates.css";

/**
 * A free tool. The tool itself is a `.tool-slot` the author puts first in the
 * body, so it sits directly under the heading; the explanation follows it.
 */
export default function ToolPage({ entry, chunk }) {
  return (
    <article className="tpl tpl--tool">
      <div className="container tpl__inner">
        <Breadcrumb entry={entry} />
        <header className="tpl__head">
          <h1 className="t-display-2">{entry.h1}</h1>
          <p className="t-lead tpl__lead">{entry.description}</p>
        </header>

        {chunk && (
          <>
            <ArticleBody html={chunk.html} slug={entry.path} lang={entry.lang} />
            <Faq items={chunk.faq} lang={entry.lang} />
            <Related paths={chunk.related} lang={entry.lang} />
          </>
        )}
      </div>
    </article>
  );
}
